module.exports = __webpack_public_path__ + "img/call-to-action-bg.25e03e2e.svg";